<div class="prev-next">
  <div class="align">
    <app-prev-next-button (click)="toHomePage()" [direction]="'left'" [icon]="'estate'"></app-prev-next-button>
  </div>
  <h1>Documentos de entrada</h1>
  <div class="align">
    <app-prev-next-button (click)="toInspection()" [direction]="'right'" [label]="'conferência física'"></app-prev-next-button>
  </div>
</div>

<div class="ctrl-bar">
  <div class="order">
    <button mat-raised-button (click)="openNfeInModal()">
      Ordem de Entrada
    </button>
  </div>

  <div class="update-button">
    <p>Atualizado às {{actualHour}}</p>
    <button mat-raised-button (click)="update()">
      <i class="uil uil-sync"></i>
      <span>Atualizar</span>
    </button>
  </div>
</div>

<div class="content">

  <app-side-color-card color="in">
    <app-in-group
      content
      [title]="'ordens criadas'"
      [type]="'ORDER'"
      [windowSize]="5"
      [documents]="createdOrders"
      [itemTemplate]="buyOrdersTemplate"
      [statePage]="isLoading">

      <ng-template #buyOrdersTemplate let-item="item" let-odd="odd">
        <app-in-group-buy-order-item
          [isOdd]="odd"
          [order]="item"
          (openModal)="openOrderDetailsModal(item)"
        ></app-in-group-buy-order-item>
      </ng-template>

      <div empty>
        NÃO EXISTEM ITENS NESSA ETAPA NESSE MOMENTO.
      </div>
      <app-in-group-buy-order-header
        header
        [activeFilterParams]="createdFilters"
        [activeSortParams]="createdSortParams"
        (filterValues)="onFiltersApply('created', $event)">
      </app-in-group-buy-order-header>
    </app-in-group>
  </app-side-color-card>


  <app-side-color-card color="in">
    <app-in-group
      content
      [title]="'ordens em recebimento'"
      [type]="'ORDER'"
      [windowSize]="5"
      [documents]="receivingOrders"
      [itemTemplate]="receivingInOrders"
      [statePage]="isLoading">

      <ng-template #receivingInOrders let-item="item" let-odd="odd">
       <app-in-group-buy-order-item
          [isOdd]="odd"
          [order]="item"
          (openModal)="openOrderDetailsModal(item)"
        ></app-in-group-buy-order-item>
      </ng-template>

      <div empty>
        NÃO EXISTEM ITENS NESSA ETAPA NESSE MOMENTO.
      </div>
      <app-in-group-buy-order-header
        header
        [activeFilterParams]="receivingFilters"
        [activeSortParams]="receivingSortParams"
        (filterValues)="onFiltersApply('receiving', $event)">
      </app-in-group-buy-order-header>
    </app-in-group>
  </app-side-color-card>
</div>

<app-full-page-loader *ngIf="isModalLoading"></app-full-page-loader>
